export const DiagnosticView = {
  FRONT: "front",
  LEFT: "left",
  BACK: "back",
  RIGHT: "right"
};

export const DiagnosticViews = [
  DiagnosticView.FRONT,
  DiagnosticView.LEFT,
  DiagnosticView.BACK,
  DiagnosticView.RIGHT
];

export const QuestionTypes = {
  MULTIPLE: "multiple",
  SINGLE: "single"
};

export const QuestionSubTypes = {
  RANGE: "range",
  LIST: "list",
  FREE_TEXT: "free_text"
};

export const QuestionKeys = {
  HUMAN_MODEL: "q_human_model",
  AGE: "q_age",
  WEIGHT: "q_weight",
  SEX: "q_sex",
  HEIGHT: "q_height",
  PAIN_VAS: "q_pain_baseline_VAS",
  PAIN_TYPE: "q_pain_baseline_pain_type"
};
export const IgnoredQuestions = [
  QuestionKeys.AGE,
  QuestionKeys.WEIGHT,
  QuestionKeys.SEX,
  QuestionKeys.HEIGHT
];



// WEBPACK FOOTER //
// ./src/modules/diagnostic/diagnostic-constants.js